module.exports = "<p>\n  welcome-message works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/welcome-message/welcome-message.component.html
// module id = ../../../../../src/app/shared/welcome-message/welcome-message.component.html
// module chunks = main